import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getDefects } from '../api/defects';
import {
  AvailableDefectLayersQuery,
  AvailableDefectLayersResponseBody,
} from '../contracts/availableLayers';
import { SurveyDataManagerApiError } from '../contracts/common';
import { resolveOverlayTenantSlug } from '../defectOverlays/tenantDefectOverlayAdapter';
import { surveyDataManagerQueryKeys } from './queryKeys';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function useDefects(
  query: AvailableDefectLayersQuery = {},
  refreshData: boolean = false,
): UseQueryResult<AvailableDefectLayersResponseBody, SurveyDataManagerApiError> {
  const tenantSlug = resolveOverlayTenantSlug();

  return useQuery<AvailableDefectLayersResponseBody, SurveyDataManagerApiError>({
    queryKey: surveyDataManagerQueryKeys.defects(query, tenantSlug),
    queryFn: ({ signal }) =>
      getDefects(query, refreshData, signal, { tenantId: tenantSlug }),
    staleTime: FIVE_MINUTES_MS,
    enabled: tenantSlug != null,
  });
}
